import React from "react";
import Seo from "components/Seo";
import CustomerLayout from "./customerLayout";
import { useState } from "react";
import { ReactComponent as PageBefore } from "assets/morning/icon/pageBefore.svg";
import { ReactComponent as PageFirst } from "assets/morning/icon/pageFirst.svg";
import Button from "../../-components/common/Button";
import { usePostRequestList } from "../../../../../hooks/morning/usePostRequestList";
import { useNavigate } from "react-router-dom";
import { useMorningAuthStore } from "../../../../../store/useMorningAuthStore";
import NoLogin from "../../../common/-pages/service/NoLogin";

const MorningInvoicesEdit = () => {
    const navigate = useNavigate();
    const accessToken = useMorningAuthStore(state => state.accessToken ?? "");

    const [page, setPage] = useState(1);

    const { data } = usePostRequestList({
        getPage: String(page),
        getPageSize: "20",
        category: "customer_4",
    });

    const maxPage = data?.last_page ?? 1;
    const pageSize = 5;
    const currentGroup = Math.floor((page - 1) / pageSize);
    const startPage = currentGroup * pageSize + 1;
    const endPage = Math.min(startPage + pageSize - 1, maxPage);

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="청구서수정요청" />
            <CustomerLayout>
                <div className="flex-1 bg-[#f8f8f8] flex flex-col items-center pt-12 responsive1200:px-[4%] responsive1200:pt-[30px]">
                    <p className="text-[#1b1c1e] text-[36px] font-bold responsive1200:text-[24px] responsive1200:font-[500]">
                        청구서수정요청
                    </p>
                    {accessToken ? (
                        <div className="bg-white mt-12 w-full max-w-[1200px] px-10 py-6 rounded-2xl flex flex-col mb-6 responsive1200:px-[4%] responsive1200:my-[30px] responsive450:py-[10%]">
                            <figure className="overflow-x-auto">
                                <table className="mt-12 text-sm min-w-[800px] w-full">
                                    <thead className="border-t-2 border-black h-12 bg-[#f8f8f8]">
                                        <tr className="text-[#333] border-b">
                                            <th className="font-[400] border-r w-[55px]">NO</th>
                                            <th className="font-[400] border-r w-[132px]">운송장번호</th>
                                            <th className="font-[400] border-r">제목</th>
                                            <th className="font-[400] border-r w-[150px]">요청업체명</th>
                                            <th className="font-[400] border-r w-[150px]">연락드릴번호</th>
                                            <th className="font-[400] border-r w-[120px]">등록일</th>
                                            <th className="font-[400] w-[99px]">상태</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-[#666]">
                                        {data?.request_list.map((list, idx) => (
                                            <tr
                                                key={idx}
                                                onClick={() =>
                                                    navigate("/customer/invoices-edit/edit", { state: { listNo: list.list_no } })
                                                }
                                                className="text-center border-b text-[#333] cursor-pointer"
                                            >
                                                <td className="border-r p-[13px]">{list.NO}</td>
                                                <td className="border-r p-[13px] text-[#233bba]">{list.운송장번호}</td>
                                                <td className="border-r p-[13px]">{list.제목}</td>
                                                <td className="border-r p-[13px]">{list.요청업체명}</td>
                                                <td className="border-r p-[13px]">{list.연락드릴번호}</td>
                                                <td className="border-r p-[13px]">{list.등록일.slice(0, 10)}</td>
                                                <td
                                                    className={`p-[13px]  ${list.상태 === "답변대기" ? "text-[#0f8217]" : "text-[#e61d27]"}`}
                                                >
                                                    {list.상태}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </figure>
                            <div className="flex justify-end mt-7">
                                <Button
                                    onClick={() => navigate("/customer/invoices-edit/register")}
                                    className="bg-[#264180] text-white border-none text-sm w-[92px] rounded-[3px]"
                                >
                                    작성하기
                                </Button>
                            </div>

                            <div className="flex justify-center items-center gap-2 mt-6">
                                <button onClick={() => setPage(1)}>
                                    <PageFirst />
                                </button>
                                <button onClick={() => setPage(Math.max(1, startPage - 1))}>
                                    <PageBefore className="mr-7" />
                                </button>
                                {Array.from({ length: endPage - startPage + 1 }).map((_, i) => {
                                    const pageNum = startPage + i;
                                    return (
                                        <button
                                            key={pageNum}
                                            className={`px-3 py-1 rounded ${pageNum === page ? "text-[#243a6f] font-bold" : "text-[#666]"}`}
                                            onClick={() => setPage(pageNum)}
                                        >
                                            {pageNum}
                                        </button>
                                    );
                                })}
                                <button onClick={() => setPage(Math.min(maxPage, endPage + 1))}>
                                    <PageBefore className="rotate-180 ml-7" />
                                </button>
                                <button onClick={() => setPage(maxPage)}>
                                    <PageFirst className="rotate-180" />
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="mt-10 w-full h-[68vh]">
                            <NoLogin status="morning" />
                        </div>
                    )}
                </div>
            </CustomerLayout>
        </React.Fragment>
    );
};

export default MorningInvoicesEdit;
